<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>

    <v-flex>
      <app-upsert
        :config="config"
        :item="returned"
        @saved="saved"/>

    </v-flex>

  </v-container>
</template>

<script>

import config from './config_new.js'
// import drugConfig from './drug_index.js'
// import drugConfirmConfig from './drug_confirm.js'
// const { upsert } = require('@/api/base_entity')

// import drugConfig from './drug_config.json'

export default {
  data ({ $store }) {
    let returned = {}
    if ($store.getters.user.site_id) {
      returned.site_id = $store.getters.user.site_id
    }
    if ($store.getters.app.protocol.id !== -1) {
      returned.protocol_id = $store.getters.app.protocol.id
    }
    return {
      config,
      returned
    }
  },
  methods: {
    saved ({ data }) {
      this.$router.push(`/returned/${data.id}`)
    }
  }
}
</script>